"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnePoint_Actions = void 0;
var OnePoint_Actions;
(function (OnePoint_Actions) {
    OnePoint_Actions["CREATE_APP"] = "OP.CREATE_APP";
    OnePoint_Actions["GET_APP_INFO"] = "OP.GET_APP_INFO";
    OnePoint_Actions["GET_APPS_BY_USER"] = "OP.GET_APP_BY_USER";
    OnePoint_Actions["GET_LIST_BY_ID"] = "OP.GET_LIST";
    OnePoint_Actions["GET_LISTS_BY_APP"] = "OP.GET_LISTS_BY_APP";
    OnePoint_Actions["GET_LIST_ITEM"] = "OP.GET_LIST_ITEM";
    OnePoint_Actions["GET_LIST_ITEMS"] = "OP.GET_LIST_ITEMS";
    OnePoint_Actions["DELETE_LIST_ITEM"] = "OP.DELETE_LIST_ITEM";
    OnePoint_Actions["CREATE_LIST_ITEM"] = "OP.CREATE_LIST_ITEM";
    OnePoint_Actions["UPDATE_LIST_FIELDS"] = "OP.UPDATE_LIST_FIELDS";
    OnePoint_Actions["UPDATE_LIST_ITEM"] = "OP.UPDATE_LIST_ITEM";
    OnePoint_Actions["UPDATE_LIST_PERMISSION"] = "OP.UPDATE_LIST_PERMISSION";
    OnePoint_Actions["CREATE_LIST"] = "OP.CREATE_LIST";
    OnePoint_Actions["CREATE_TEAM"] = "OP.CREATE_TEAM";
    OnePoint_Actions["TEAM_ADD_MEMBER"] = "OP.TEAM_ADD_MEMBER";
    OnePoint_Actions["GET_TEAMS_CURRENTMEMBER"] = "OP.GET_TEAMS_CURRENTMEMBER";
    OnePoint_Actions["SHARE_ITEMS_PUBLIC"] = "OP.SHARE_ITEMS_PUBLIC";
    // PUBLIC ACTION
    OnePoint_Actions["PUBLIC_GET_PUBLIC_ITEM"] = "OP.PUBLIC.GET_SHARE_ITEM";
})(OnePoint_Actions = exports.OnePoint_Actions || (exports.OnePoint_Actions = {}));
//# sourceMappingURL=action.define.js.map